import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M12.5 18C12.224 18 12 17.776 12 17.5V11H10.5C10.224 11 10 10.776 10 10.5C10 10.224 10.224 10 10.5 10H12C12.551 10 13 10.449 13 11V17.5C13 17.776 12.776 18 12.5 18Z"
      fill="currentColor"
    />
    <path
      d="M11.9831 22C9.5081 22 7.1531 21.097 5.3001 19.427C3.3171 17.64 2.1501 15.188 2.0131 12.523C1.8731 9.85597 2.7811 7.29397 4.5671 5.30897C6.3531 3.32397 8.8071 2.15297 11.4731 2.01397C14.1461 1.88097 16.7031 2.78197 18.6881 4.56997C20.6731 6.35797 21.8451 8.81097 21.9851 11.478C22.1061 13.894 21.3581 16.263 19.8801 18.151C19.7091 18.369 19.3961 18.404 19.1781 18.236C18.9611 18.066 18.9231 17.752 19.0931 17.534C20.4231 15.836 21.0961 13.704 20.9881 11.53C20.8621 9.13097 19.8081 6.92297 18.0201 5.31397C16.2321 3.70497 13.9141 2.88097 11.5261 3.01397C9.1261 3.13897 6.9191 4.19197 5.3111 5.97897C3.7031 7.76597 2.8861 10.072 3.0121 12.472C3.1351 14.87 4.1851 17.076 5.9701 18.685C7.7581 20.296 10.0641 21.098 12.4681 20.988C14.2601 20.894 15.9611 20.279 17.3851 19.209C17.6071 19.041 17.9201 19.088 18.0851 19.308C18.2501 19.528 18.2071 19.842 17.9861 20.008C16.4011 21.199 14.5101 21.883 12.5191 21.987C12.3411 21.995 12.1621 22 11.9831 22V22Z"
      fill="currentColor"
    />
    <path
      d="M13 8C13 8.552 12.552 9 12 9C11.448 9 11 8.552 11 8C11 7.448 11.448 7 12 7C12.552 7 13 7.448 13 8Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'Info');

export default Icon;
